import { z } from "zod";
import { PreValidationStatus } from "./EAppValidation";

const ValidationObject = z.object({
  id: z.string().nullish(),
  content: z.string().nullish(),
  title: z.string().nullish(),
})

export const AppPreValidation = z.object({
  status: z.nativeEnum(PreValidationStatus).nullish(),
  errors: z.array(ValidationObject).optional().nullish(),
  warnings: z.array(ValidationObject).optional().nullish(),
  notes: z.array(ValidationObject).optional().nullish(),
});

export type IPreValidation = z.infer<typeof AppPreValidation>;
